import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ShButtonComponent } from '../button/button.component';
import { ShMenuComponent, ShMenuItem } from './menu.component';

/**
 * An icon-only ⋮ button that opens a popup menu: the row / card overflow
 * menu. The same inputs as `sh-action-menu`, so switching is 1:1.
 *
 *   <sh-menu-button [items]="rowActions" [context]="row" />
 *
 * A click on the button does not reach the row it sits in.
 */
@Component({
  selector: 'sh-menu-button',
  // Default, not OnPush: `visible` / `disabled` functions over page state.
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [ShButtonComponent, ShMenuComponent],
  template: `
    <sh-button
      variant="text"
      size="sm"
      [rounded]="true"
      [icon]="icon()"
      [ariaLabel]="ariaLabel()"
      (click)="menu.toggle($event)"
    ></sh-button>
    <sh-menu #menu [items]="items()" [context]="context()"></sh-menu>
  `,
})
export class ShMenuButtonComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly items = input.required<ShMenuItem<any>[]>();
  readonly context = input<unknown>();
  /** Font Awesome classes. */
  readonly icon = input('fa-solid fa-ellipsis-vertical');
  /** Translation key or plain text. `shared.terms.actions` exists in every app. */
  readonly ariaLabel = input('shared.terms.actions');
}
